import React from 'react';
import { gap } from '../gridSettings';
export const Row = ({ children, className = '', gutter = gap, gutterY = 0, justify = 'flex-start', align = 'stretch', }) => (<>
    <div className={`bl-haven-row ${className}`}>{children}</div>
    <style global jsx>
      {`
        .bl-haven-row {
          display: flex;
          flex-wrap: wrap;
        }
      `}
    </style>
    <style jsx>
      {`
        .bl-haven-row {
          justify-content: ${justify};
          align-items: ${align};
          margin-right: ${gutter ? `${gutter / -2}px` : '0'};
          margin-left: ${gutter ? `${gutter / -2}px` : '0'};
          ${gutterY > 0
        ? `
              margin-top: ${gutterY ? `${gutterY / -2}px` : '0'};
              margin-bottom: ${gutterY ? `${gutterY / -2}px` : '0'};
              `
        : ''}
        }
      `}
    </style>
  </>);
